
import { Component, Prop, Vue } from 'vue-property-decorator';
import type { Project } from '@/models/project';
import PMPhaseWorksheet from '@/components/projects/fields/PMPhaseWorksheet.vue';

@Component({
    name: 'ProjectViewPMGrid',
    components: {
        PMPhaseWorksheet,
    },
})
export default class ProjectViewPMGrid extends Vue {
    @Prop({
        required: true,
    })
    private project: Project;
}
